import React from "react";

const TipCard = ({ icon = "💡", title = "הידעת?", children, style = {} }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "center",
        margin: "0 auto 24px auto",
        maxWidth: 600,
        background: "linear-gradient(90deg, #fff7ed 0%, #ffe0b2 100%)",
        borderRadius: 20,
        boxShadow: "0 4px 24px rgba(255, 152, 0, 0.10)",
        padding: 32,
        fontWeight: 800,
        fontSize: "1.18rem",
        color: "#e65100",
        direction: "rtl",
        gap: 18,
        border: "1.5px solid #ffd180",
        letterSpacing: 0.2,
        ...style,
      }}
    >
      <div style={{ width: "100%", textAlign: "right", marginBottom: 8 }}>
        <span
          style={{
            fontWeight: 900,
            fontSize: "1.25em",
            color: "#ff9800",
            letterSpacing: 0.5,
            textShadow: "0 2px 8px #fffde7",
          }}
        >
          {title}
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <span
          role="img"
          aria-label="tip"
          style={{
            fontSize: 36,
            marginLeft: 20,
            flexShrink: 0,
            filter: "drop-shadow(0 2px 6px #ffd18088)",
            textShadow: "0 2px 8px #fffde7",
          }}
        >
          {icon}
        </span>
        <span style={{ flex: 1, fontWeight: 800, lineHeight: 1.6 }}>
          {children}
        </span>
      </div>
    </div>
  );
};

export default TipCard;
